export const REQUIREMENT_PRINT_STYLES = `
  .req-print-root * { box-sizing: border-box; }
  .req-print-root {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 11pt;
    color: #1f2937;
    line-height: 1.5;
    background: white;
  }
  .req-print-root .print-container {
    background: white;
    padding: 10mm 8mm;
    width: 210mm;
    min-height: auto;
  }
  .req-print-root .header {
    text-align: center;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 2px solid #0d9488;
  }
  .req-print-root .header h1 {
    font-size: 18pt;
    font-weight: bold;
    color: #0d9488;
    margin: 0;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .req-print-root .info-compact {
    margin-bottom: 12px;
    font-size: 10pt;
    line-height: 1.5;
    color: #374151;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  .req-print-root .info-compact-line { margin-bottom: 0; }
  .req-print-root .info-compact-label { font-weight: 600; color: #0d9488; }
  .req-print-root .info-compact-sep { color: #9ca3af; }
  .req-print-root .status-badge {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 8pt;
    font-weight: 600;
    text-transform: uppercase;
  }
  .req-print-root .items-card {
    margin-top: 8px;
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    padding: 10px;
  }
  .req-print-root .items-title {
    font-weight: 700;
    font-size: 11pt;
    color: #0d9488;
    margin-bottom: 10px;
    padding-bottom: 5px;
    border-bottom: 2px solid #0d9488;
    text-transform: uppercase;
  }
  .req-print-root .items-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 8pt;
    table-layout: fixed;
  }
  .req-print-root .items-table thead { background: #0d9488; color: white; }
  .req-print-root .items-table th {
    padding: 7px 5px;
    text-align: left;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 7pt;
    border: 1px solid #0d9488;
  }
  .req-print-root .items-table td {
    padding: 7px 5px;
    border: 1px solid #e5e7eb;
    background: white;
    vertical-align: top;
  }
  .req-print-root .items-table tbody tr:nth-child(even) td { background: #f9fafb; }
  .req-print-root .items-table th.num,
  .req-print-root .items-table td.num { text-align: right; }
  .req-print-root .items-table th:nth-child(1),
  .req-print-root .items-table td:nth-child(1) { width: 50%; }
  .req-print-root .items-table th:nth-child(2),
  .req-print-root .items-table td:nth-child(2) { width: 10%; text-align: center; }
  .req-print-root .items-table th:nth-child(3),
  .req-print-root .items-table td:nth-child(3) { width: 28%; }
  .req-print-root .items-table th:nth-child(4),
  .req-print-root .items-table td:nth-child(4) { width: 12%; }
  .req-print-root .product-name { font-weight: 600; color: #1f2937; }
  .req-print-root .product-notes { font-size: 7pt; color: #6b7280; margin-top: 3px; }
  .req-print-root .print-footer-obs {
    margin-top: 12px;
    font-size: 9pt;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .req-print-root .print-obs-label { font-weight: 600; color: #0d9488; }
  .req-print-root .print-obs-text {
    white-space: pre-wrap;
    word-wrap: break-word;
    line-height: 1.3;
    color: #374151;
  }
`;

export const REQUIREMENT_PRINT_PAGE_STYLES = `
  @page { size: A4; margin: 10mm 8mm; }
  @media print {
    * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
    body { margin: 0; padding: 0; background: white; }
    .no-print { display: none !important; }
    .req-print-root .print-container { padding: 0; margin: 0; max-width: 100%; box-shadow: none; width: 100%; }
  }
  @media screen {
    body { background: #f3f4f6; }
    .req-print-root .print-container {
      max-width: 210mm;
      margin: 20px auto;
      background: white;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    }
    .print-actions { position: fixed; top: 20px; right: 20px; z-index: 1000; display: flex; gap: 10px; }
  }
  @media print {
    .req-print-root .print-footer-obs,
    .req-print-root .items-card { page-break-inside: avoid; }
  }
`;
